import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { reconClient } from '../../../utils/axios';
import { RECON_LIST_POLL_INTERVAL_MS, SESSION_STATUSES } from '../utils/reconConstants';

// GET /api/v1/uploads — upload sessions, newest first ({items, total}).
export const fetchUploads = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await reconClient.get('/uploads', { params, skipErrorSnackbar: true });
  return data;
};

export const useGetUploadsHandler = ({ page = 0, pageSize = 10, enabled = true } = {}) => {
  const dispatch = useDispatch();

  const params = { limit: pageSize, offset: page * pageSize };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['recon-uploads', params],
    queryFn: fetchUploads,
    enabled,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    // Live progress while any session is still ingesting.
    refetchInterval: (query) => {
      const items = query.state.data?.items ?? [];
      return items.some((s) => s.status === SESSION_STATUSES.PROCESSING) ? RECON_LIST_POLL_INTERVAL_MS : false;
    },
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      const message = error?.response?.data?.detail ?? error?.message ?? 'Failed to load upload sessions';
      dispatch(showSnackbar({ message, severity: 'error' }));
    }
  }, [dispatch, error, isError]);

  return { sessions: data?.items ?? [], totalSessions: data?.total ?? 0, isLoading };
};
